var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFriendList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_19392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 122.01L36.5385 40.3726H82.4038L114 122.01H8Z",
    fill: "url(#paint0_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.3364 28.2225C33.2521 16.5003 45.0045 6.94726 59.5369 6.86383C74.0693 6.7804 85.948 16.2082 85.9901 27.8888L33.3364 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2888 27.8889C44.2466 19.8377 51.576 13.2465 60.7167 13.2048C69.8574 13.1631 77.271 19.6291 77.3132 27.722L44.2888 27.8889Z",
    fill: "url(#paint1_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3366 28.2224L19.1411 33.6455L99.9751 33.1866L86.2851 27.8887L33.3366 28.2224Z",
    fill: "url(#paint2_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.184 33.1711L16.7967 33.7004C15.806 33.7065 15.0079 34.5145 15.014 35.5052C15.0202 36.4959 15.8283 37.2941 16.8189 37.288L103.206 36.7587C104.197 36.7526 104.995 35.9446 104.989 34.9539C104.983 33.9632 104.175 33.165 103.184 33.1711Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2245 44.4504C42.2245 44.4504 24.7014 40.7794 20.2363 37.2335L46.4368 37.0666L99.4696 36.7329C99.4696 36.7329 88.1386 44.367 77.5657 44.2418C77.5657 44.2418 77.4393 47.8294 73.3113 47.8294C69.1832 47.8711 46.7738 47.9963 46.7738 47.9963C46.7738 47.9963 41.6769 47.162 41.6769 44.3253",
    fill: "url(#paint3_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3635 24.4681C47.3214 24.3012 47.2793 24.1343 47.2793 23.9675C47.1108 20.9639 50.944 16.2083 54.0611 15.958C55.2827 15.8745 56.757 17.0009 56.0409 18.2941C55.1142 20.0044 53.9347 21.5479 52.7132 23.0497C51.8286 24.1761 50.6913 26.1367 48.9642 25.7613C48.206 25.6361 47.6163 25.1772 47.3635 24.4681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.5793 24.1344C59.5793 25.3024 58.6526 26.2619 57.431 26.2619C56.2515 26.2619 55.2827 25.3441 55.2827 24.1344C55.2827 22.9663 56.2094 22.0068 57.431 22.0068C58.6104 22.0486 59.5793 22.9663 59.5793 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5041 34.6634L17.0244 34.7152C16.6558 34.7174 16.3588 35.0181 16.3611 35.3867C16.3634 35.7553 16.6641 36.0523 17.0327 36.0501L25.5124 35.9983C25.8811 35.9961 26.178 35.6954 26.1757 35.3268C26.1734 34.9581 25.8728 34.6611 25.5041 34.6634Z",
    fill: "url(#paint4_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3318 34.6635L31.852 34.7152C31.4834 34.7174 31.1864 35.0181 31.1887 35.3867C31.191 35.7553 31.4917 36.0523 31.8603 36.0501L40.3401 35.9984C40.7087 35.9962 41.0057 35.6955 41.0034 35.3269C41.0011 34.9583 40.7004 34.6613 40.3318 34.6635Z",
    fill: "url(#paint5_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2009 34.6635L46.7212 34.7152C46.3525 34.7174 46.0556 35.0181 46.0579 35.3867C46.0601 35.7553 46.3608 36.0523 46.7295 36.0501L55.2092 35.9984C55.5778 35.9962 55.8748 35.6955 55.8725 35.3269C55.8702 34.9583 55.5695 34.6613 55.2009 34.6635Z",
    fill: "url(#paint6_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.029 34.705L61.5493 34.7567C61.1807 34.7589 60.8837 35.0596 60.886 35.4282C60.8883 35.7968 61.189 36.0938 61.5576 36.0916L70.0373 36.0399C70.406 36.0376 70.7029 35.737 70.7006 35.3684C70.6983 34.9997 70.3977 34.7027 70.029 34.705Z",
    fill: "url(#paint7_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8987 34.5795L76.4189 34.6312C76.0503 34.6334 75.7533 34.9341 75.7556 35.3027C75.7579 35.6713 76.0586 35.9683 76.4272 35.9661L84.907 35.9144C85.2756 35.9122 85.5726 35.6115 85.5703 35.2429C85.568 34.8742 85.2673 34.5772 84.8987 34.5795Z",
    fill: "url(#paint8_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7263 34.4544L91.2466 34.5062C90.8779 34.5084 90.581 34.8091 90.5833 35.1777C90.5855 35.5463 90.8862 35.8433 91.2549 35.8411L99.7346 35.7894C100.103 35.7871 100.4 35.4865 100.398 35.1178C100.396 34.7492 100.095 34.4522 99.7263 34.4544Z",
    fill: "url(#paint9_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint10_linear_413_19392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 83.6939C64.0787 83.6939 67.385 80.4045 67.385 76.3469C67.385 72.2893 64.0787 69 60.0003 69C55.9219 69 52.6157 72.2893 52.6157 76.3469C52.6157 80.4045 55.9219 83.6939 60.0003 83.6939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8462 86.7554H56.1538C51.6923 86.7554 48 90.429 48 94.8677C48 95.9391 48.4615 96.8576 49.3846 97.3167C50.7692 98.082 53.8462 99.0002 60 99.0002C66.1539 99.0002 69.2307 98.082 70.6154 97.3167C71.3846 96.8576 72 95.9391 72 94.8677C72 90.2759 68.3078 86.7554 63.8462 86.7554Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_19392",
    x1: 61,
    y1: 40.3726,
    x2: 61,
    y2: 122.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_413_19392",
    x1: 60.8009,
    y1: 13.2046,
    x2: 60.8009,
    y2: 27.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_413_19392",
    x1: 59.5581,
    y1: 27.8887,
    x2: 59.5581,
    y2: 33.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_413_19392",
    x1: 67.9999,
    y1: 48.2005,
    x2: 67.9999,
    y2: 36.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_413_19392",
    x1: 16.3629,
    y1: 35.6766,
    x2: 26.1775,
    y2: 35.6155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_413_19392",
    x1: 31.1905,
    y1: 35.6766,
    x2: 41.0052,
    y2: 35.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_413_19392",
    x1: 46.0597,
    y1: 35.6766,
    x2: 55.8743,
    y2: 35.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_413_19392",
    x1: 60.8878,
    y1: 35.7181,
    x2: 70.7024,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_413_19392",
    x1: 75.7574,
    y1: 35.5926,
    x2: 85.5721,
    y2: 35.5316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_413_19392",
    x1: 90.5851,
    y1: 35.4676,
    x2: 100.4,
    y2: 35.4066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_413_19392",
    x1: 60,
    y1: 57,
    x2: 60,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_19392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFriendList);
export default __webpack_public_path__ + "static/media/no_friend_list.8b677b4100b9a145fa2f712e694623d1.svg";
export { ForwardRef as ReactComponent };